import { render, staticRenderFns } from "./PageContentSectionsTemplateMenu.vue?vue&type=template&id=e85dd142&scoped=true"
import script from "./PageContentSectionsTemplateMenu.vue?vue&type=script&lang=js"
export * from "./PageContentSectionsTemplateMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85dd142",
  null
  
)

export default component.exports